module.exports = __webpack_public_path__ + "img/pdf_to_excel.3e126fab.png";